<sl-dialog
    #modal
    [open]="open$() | async"
    [noHeader]="true"
    (sl-request-close)="preventClose($event)"
    (sl-hide)="handleHide()">

  <ng-container [ngSwitch]="type$() | async">

    <!-- Switch Case: RESTART -->
    <ng-container *ngSwitchCase="'RESTART'">
      <app-restart-form-modal [message]="getData().message" />
    </ng-container>

    <!-- Switch Case: ALERT -->
    <ng-container *ngSwitchCase="'ALERT'">
      <div class="modal-alert">
        <div class="modal-alert__content">
          <div class="modal-alert-content__icon modal-alert-content__icon--red">
            <sl-icon name="exclamation-octagon"></sl-icon>
          </div>
          <div class="modal-alert-content__text">
            {{ getData().message }}
          </div>
        </div>
        <div class="modal-alert__actions">
          <sl-button class="btn--secondary" type="button" (click)="closeModal()">Close</sl-button>
        </div>
      </div>
    </ng-container>

  </ng-container>
</sl-dialog>